<script lang="ts">
    import cn from 'classnames';

    import cs from '@components/common/common.module.css';

    import s from './dialog.module.css';

    export let classes = '';
    export let style = '';
    export let enableScroll = true;
    export let testId = 'dialog';
</script>

<div
    {style}
    data-testid={testId}
    id="dialog-container"
    data-bodyscrollignore
    class={cn(
        s.root,
        {
            [cs.verticalScrollbar]: enableScroll,
        },
        classes
    )}
>
    <slot />
</div>
